<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form
        (ngSubmit)="save()"
        *ngIf="layers?.length && editForm"
        [formGroup]="editForm"
        [windeDisableFormControls]="editForm"
        class="dialog-form"
        name="editForm"
>
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>{{ 'project.home.layersSettingsLabel' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>
    <div class="siklu-mat-dialog-body" matDialogContent>
        <winde-alert-error></winde-alert-error>
        <div class="row">
            <div *ngIf="layerNames?.length" class="col-3 layers-settings-tabs">
                <winde-tabs-nav
                        (tabChanged)="changeLayerTab($event)"
                        [activeTab]="activeLayerIndex"
                        [customClass]="'tabs-nav--borderless'"
                        [tabsList]="layerNames"
                ></winde-tabs-nav>
            </div>
            <div *ngIf="layersControlsArr?.controls?.length" [formGroupName]="'layers'" class="col-9">
                <ng-container *ngFor="let control of layersControlsArr.controls; let layerIndex = index">
                    <ng-container *ngIf="activeLayerIndex === layerIndex">
                        <div [formGroupName]="'' + layerIndex" class="form-group row justify-content-start mt-3">
                            <label
                                    class="form-control-label col-4 mt-auto"
                                    for="layer_name_{{ layerIndex }}"
                            >{{ layers[layerIndex].layerPrefix }} name</label
                            >
                            <div class="col-8">
                                <input
                                        class="form-control"
                                        formControlName="layerName"
                                        id="layer_name_{{ layerIndex }}"
                                        maxlength="250"
                                        required
                                        type="text"
                                />
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button matDialogClose windeTransparent>
            <sui-svg-icon icon="cross"/>
            {{ 'entity.action.cancel' | translate }}
        </button>
        <button type="submit" windeGreen>
            <sui-svg-icon icon="save"/>
            {{ 'entity.action.save' | translate }}
        </button>
    </div>
</form>
